import { updateObject } from '../../shared/utility';
import {
    CORRECTION_START,
    CORRECTION_SUCCESS,
    CORRECTION_FAIL,
} from '../actions/actionTypes';

const initialState={
    error:null,
    message:null,
    loading:false,
}

const correctionStart=(state,action)=>{
    return updateObject(state,{error:null,message:null,loading:true});
}

const correctionSuccess=(state,action)=>{
    return updateObject(state,{error:null,message:'correction success',loading:false});
}

const correctionFail=(state,action)=>{
    return updateObject(state,{error:action.payload,message:null,loading:false});
}

const correctionReducer=(state=initialState,action)=>{
    switch(action.type){
        case CORRECTION_START:
            return correctionStart(state,action);
        case CORRECTION_SUCCESS:
            return correctionSuccess(state,action);
        case CORRECTION_FAIL:
            return correctionFail(state,action);
        default:
            return state;
    }
}

export default correctionReducer;